import React from "react";

export const FileSignSvg = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.25">
          <path
            d="M21.5169 7.99175C21.9148 8.55833 21.4405 9.25 20.7482 9.25H3.5C2.94772 9.25 2.5 8.80228 2.5 8.25V6.42C2.5 3.98 4.48 2 6.92 2H9.24C10.87 2 11.38 2.53 12.03 3.4L13.43 5.26C13.74 5.67 13.78 5.72 14.36 5.72H17.15C18.9546 5.72 20.5516 6.61709 21.5169 7.99175Z"
            fill="#292D32"
          />
          <path
            d="M22.4834 11.7461C22.4815 11.1952 22.0343 10.7495 21.4834 10.7495L3.49998 10.7498C2.94771 10.7499 2.5 11.1976 2.5 11.7498V16.6499C2.5 19.5999 4.9 21.9999 7.85 21.9999H17.15C20.1 21.9999 22.5 19.5999 22.5 16.6499L22.4834 11.7461ZM15 16.7499H13.31V18.4999C13.31 18.9099 12.97 19.2499 12.56 19.2499C12.14 19.2499 11.81 18.9099 11.81 18.4999V16.7499H10C9.59 16.7499 9.25 16.4099 9.25 15.9999C9.25 15.5899 9.59 15.2499 10 15.2499H11.81V13.4999C11.81 13.0899 12.14 12.7499 12.56 12.7499C12.97 12.7499 13.31 13.0899 13.31 13.4999V15.2499H15C15.41 15.2499 15.75 15.5899 15.75 15.9999C15.75 16.4099 15.41 16.7499 15 16.7499Z"
            fill="#292D32"
          />
        </g>
      </svg>
    </>
  );
};
